








































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Webinar as IWebinar } from "@/api/models/webinar";
import { User as IUser } from "@/api/models/user";
import { getCurrentUserId, isRoot } from "@/plugins/roles";
import { goToWebinar } from "@/plugins/go-to";
import api from "@/getinfo-api";
import moment from "moment";
import { BBBRecord as IBBBRecord } from "@/api/models/bbbrecord";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";

@Component
export default class WebinarListItem extends Vue {
  @Prop() webinar!: IWebinar;
  @Prop() accessTokenDev?: any;
  @Prop() accessTokenProd?: any;
  currentAccessToken!: string;
  detailOpen: boolean = false;
  webinarTeacher!: IUser;
  bbbRecord?: Array<IBBBRecord>;
  data() {
    return {
      currentAccessToken: undefined,
      thirdPartyWebinar: undefined,
      bbbWebinar: undefined,
      webinarTeacher: undefined,
      bbbRecord: undefined
    };
  }

  getTimeAccess() {
    if (this.webinar.status === "running") {
      this.goToWebinarLink();
    }

    if (this.webinar.status === "coming") {
      if (this.availableNotStartedWebinar) {
        this.goToWebinarLink();
      } else {
        this.$bvToast.toast(
          `${this.$tc(
            this.$translate.YouCanEnterTheWebinarRoomOnlyMinutesBeforeTheStart
          )}`,
          {
            variant: "danger",
            title: `${this.$tc(this.$translate.Error)}`
          }
        );
      }
    }

    if (this.webinar.status === "finished") {
      this.$bvToast.toast(this.$tc(this.$translate.Ended), {
        variant: "danger",
        title: this.$tc(this.$translate.Error)
      });
    }
  }

  get availableNotStartedWebinar() {
    let result = false;
    if (this.webinar.status === "coming") {
      let started = new Date(this.webinar.startedAt).getTime();
      let tenMinutes = started - 600000;
      let now = new Date().getTime();
      if (now < started && now >= tenMinutes) {
        result = true;
      }
    }
    return result;
  }

  getBBBRecord() {
    api.BBBWebinarApi.getRecordings(this.webinar.id).then(
      (res: { data: Array<IBBBRecord> }) => {
        this.bbbRecord = res.data;
      }
    );
  }

  get screenWidth() {
    return window.innerWidth;
  }

  get ownerWebinar() {
    return this.webinar.ownerId === this.userId;
  }

  goToPlaybackWebinar(route: string) {
    let playbackWebinar = document.createElement("a");
    playbackWebinar.href = route;
    playbackWebinar.target = "_blank";
    playbackWebinar.click();
  }

  goToDeskShareVideoUrl(route: string) {
    let deskShareVideoUrl = document.createElement("a");
    deskShareVideoUrl.href = route;
    deskShareVideoUrl.target = "_blank";
    deskShareVideoUrl.click();
  }

  goToWebcamVideoUrl(route: string) {
    let webcamVideoUrl = document.createElement("a");
    webcamVideoUrl.href = route;
    webcamVideoUrl.target = "_blank";
    webcamVideoUrl.click();
  }

  showDetail() {
    this.detailOpen = !this.detailOpen;
    if (this.detailOpen) {
      this.getTeacher();
    }
    if (this.webinar.type === "bbb") this.getBBBRecord();
  }

  goToWebinarLink() {
    goToWebinar(this.webinar.id, this.currentAccessToken);
  }

  getTeacher() {
    api.UsersApi.get(this.webinar.ownerId)
      .then((res: { data: IUser }) => {
        this.webinarTeacher = res.data;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  get selectedCompany() {
    return this.$store.getters.selectedCompany;
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  get webinarOwner() {
    return this.webinar.ownerId === this.userId;
  }

  get webinarCompanyOwner() {
    let result: boolean = false;
    if (this.selectedCompany.id === this.webinar.companyId) {
      if (this.selectedCompany.owner.id === this.userId) {
        result = true;
      }
    }
    return result;
  }

  get canEdit() {
    return this.root || this.webinarCompanyOwner || this.webinarOwner;
  }

  get durationWebinar() {
    let start = moment(this.webinar.startedAt);
    let end = moment(this.webinar.finishedAt);
    let diff = end.diff(start);
    return moment.utc(diff).format("HH:mm");
  }

  created() {
    this.currentAccessToken = this.accessTokenDev
      ? this.accessTokenDev.accessToken
      : this.accessTokenProd.accessToken;
  }

  get styleForWebinarStatus() {
    let name = "";
    if (this.webinar.status === "coming") name = "webinar_coming";
    if (this.webinar.status === "running") name = "webinar_running";
    if (this.webinar.status === "finished") name = "webinar_finished";
    return name;
  }

  get webinarFormattedType() {
    return this.webinar.type === "bbb"
      ? this.$tc(this.$translate.Own)
      : this.$tc(this.$translate.Thirdparty);
  }

  get webinarStatus() {
    let webinarStatus: string = "";
    if (this.webinar.status === "coming")
      webinarStatus = this.$tc(this.$translate.WebinarNotStarted);
    if (this.webinar.status === "running")
      webinarStatus = this.$tc(this.$translate.Online);
    if (this.webinar.status === "finished")
      webinarStatus = this.$tc(this.$translate.Ended);
    return webinarStatus;
  }
}
